import request from '@/api/request'

export function getGpsDeviceById (deviceId) {
  return request({
    url: 'webapi/gps/device/getGpsDeviceByDeviceId/' + deviceId,
    method: 'get'
  })
}

export function getGpsDeviceByImei (deviceImei) {
  const req = {
    deviceImei
  }
  return request({
    url: 'webapi/gps/device/getSingleDevice',
    method: 'post',
    data: req
  })
}

export function listGpsDevice (data) {
  const req = {
    deviceImei: data.deviceImei,
    pageNum: data.pageNum,
    pageSize: data.pageSize
  }
  return request({
    url: 'webapi/gps/device/list',
    method: 'post',
    data: req
  })
}

export function deleteGpsDevice (deviceId) {
  const data = {
    deviceId: deviceId
  }
  return request({
    url: 'webapi/gps/device/deleteGpsDevice',
    method: 'post',
    data: data
  })
}

export function batchDeleteGpsDevice (deviceIds) {
  return request({
    url: 'webapi/gps/device/batchDeleteGpsDevice',
    method: 'post',
    data: deviceIds
  })
}

export function downloadImportTemplate() {
  return request({
    url: 'webapi/gps/device/importTemplate',
    method: 'get',
    responseType: 'blob'
  })
}

export function updateGpsDevice (data) {
  const req = {
    deviceId: data.deviceId,
    deviceImei: data.deviceImei,
    deviceName: data.deviceName,
    deviceType: data.deviceType,
    deviceRemark: data.deviceRemark,
    timeZone: data.timeZone,
    baseMileage: data.baseMileage,
    deptId: data.deptId,
    bindMobile: data.bindMobile,
    expireDate: data.expireDate,
    deviceStatus: data.deviceStatus
  }
  return request({
    url: 'webapi/gps/device/updateGpsDevice',
    method: 'post',
    data: req
  })
}

export function insertGpsDevice (data) {
  const req = {
    deviceImei: data.deviceImei,
    deviceName: data.deviceName,
    deviceType: data.deviceType,
    deviceRemark: data.deviceRemark,
    timeZone: data.timeZone,
    baseMileage: data.baseMileage,
    deptId: data.deptId,
    bindMobile: data.bindMobile,
    expireDate: data.expireDate
  }
  return request({
    url: 'webapi/gps/device/insertGpsDevice',
    method: 'post',
    data: req
  })
}

export function listGpsDeviceByMenu () {
  return request({
    url: 'webapi/gps/device/listGpsDeviceByMenu',
    method: 'get'
  })
}

export function listAllGpsDevice () {
  return request({
    url: 'app/device/listDevice',
    method: 'get'
  })
}

export function getAllDeviceByCustomer(){
  return request({
    url: 'webapi/gps/device/getAllDeviceByCustomer',
    method: 'get'
  })
}

export function lastDevicePosition (data) {
  const req = {
    deviceImei: data
  }
  return request({
    url: 'webapi/app/device/getSingleDevice',
    method: 'post',
    data: req
  })
}

export function getDeviceTankByDeviceId (deviceId) {
  return request({
    url: 'webapi/gps/device/getDeviceTankByDeviceId/' + deviceId,
    method: 'get'
  })
}


export function updateDeviceTankConfig (data) {
  const req = {
    deviceId: data.deviceId,
    ad1Max: data.ad1Max,
    ad1Min: data.ad1Min,
    ad2Max: data.ad2Max,
    ad2Min: data.ad2Min,
    ad3Max: data.ad3Max,
    ad3Min: data.ad3Min,
    ad4Max: data.ad4Max,
    ad4Min: data.ad4Min
  }
  return request({
    url: 'webapi/gps/device/updateDeviceTankConfig',
    method: 'post',
    data: req
  })
}

/**
 * 获取多个设备轨迹数据
 * @param {*} jsonArray 多个设备的数据
 */
export function getMultipleDeviceTraceLog (jsonArray) {
  const req = {
    requestList: jsonArray
  }
  return request({
    url: 'webapi/gps/location/getMultipleDeviceTraceLog',
    method: 'post',
    data: req
  })
}

/**
 * 获取多个设备轨迹数据(多天)
 * @param {*} jsonArray 多个设备的数据
 */
export function getSelectDateMultipleDeviceTraceLog (jsonArray) {
  const req = {
    requestList: jsonArray
  }
  return request({
    url: 'webapi/gps/location/getSelectDateMultipleDeviceTraceLog',
    method: 'post',
    data: req
  })


}



   /**
   * 转移设备 给指定用户
   */
   export function getTransferDevice (deviceImei, customerId) {

    const req = {
    
      deviceImei: deviceImei,
      customerId: customerId,
      
    }
    return request({
      url: 'webapi/gps/device/changeDeviceCustomer',
      method: 'post',
      data: req
    })


  }

